import { createPortal } from 'react-dom';

export interface PuzzleTouchDragGhostState {
  questionId: number;
  optionId: number;
  clientX: number;
  clientY: number;
  offsetX: number;
  offsetY: number;
  width: number;
  height: number;
}

interface PuzzleTouchDragGhostProps {
  ghost: PuzzleTouchDragGhostState;
  wordText: string;
  className?: string;
  textDir?: string;
}

/** Render drag ghost on `document.body` so viewport coords stay correct inside transformed modals. */
export function PuzzleTouchDragGhost({
  ghost,
  wordText,
  className = 'inline-flex items-center justify-center px-3 py-1.5 sm:px-2 sm:py-1 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 border border-blue-400 dark:border-blue-500 shadow-md select-none',
  textDir,
}: PuzzleTouchDragGhostProps) {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      style={{
        position: 'fixed',
        left: ghost.clientX - ghost.offsetX,
        top: ghost.clientY - ghost.offsetY,
        width: ghost.width,
        height: ghost.height,
        zIndex: 220,
        pointerEvents: 'none',
      }}
      className={className}
    >
      <span className="font-medium text-sm leading-tight whitespace-nowrap" dir={textDir ?? 'auto'}>
        {wordText}
      </span>
    </div>,
    document.body
  );
}
